import script from "./LoyaltyDiscountsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./LoyaltyDiscountsSection.vue?vue&type=script&setup=true&lang=js"

import "./LoyaltyDiscountsSection.vue?vue&type=style&index=0&id=0b2468c0&scoped=true&lang=css"

import exportComponent from "/home/armin/w/euro-petrol-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b2468c0"]])

export default __exports__